<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->

    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel">
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">LICENSE INFO - MEIS</h2>
                </div>
                <div class="form">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>MEIS License Number</label><span style="color: red;">*</span><br />
                            <input type="text" [(ngModel)]="LicenseNumber" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>License Date</label><span style="color: red;">*</span><br />
                            <input type="date" [(ngModel)]="LicenseDate" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Valid From</label><span style="color: red;">*</span><br />
                            <input type="date" [(ngModel)]="ValidFrom" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Valid To</label><span style="color: red;">*</span><br />
                            <input type="date" [(ngModel)]="ValidTo" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>License Value (INR)</label><span style="color: red;">*</span><br />
                            <input type="number" [(ngModel)]="LicValue" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Available Value (INR)</label><span style="color: red;">*</span><br />
                            <input type="number" [(ngModel)]="AvlValue" class="txt-input" />
                        </div>
                        <div class="col-lg-2" style="text-align: left;">
                            <label>ROQ</label><span style="color: red;">*</span><br />
                            <input type="number" [(ngModel)]="Roq" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Current Status</label><br />
                            <input type="text" [(ngModel)]="crntstatus" class="txt-input" readonly/>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 10px;">
                        <div class="col-lg-4">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" id="description" [(ngModel)]="Description"
                                class="txt-input"></textarea>
                        </div>
                        <div class="col-lg-2" style="padding-top:60px;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 50px;">
                            <button class="bttn-save" (click)="Submitlic()" [hidden]="isShownSaveBtn">SAVE</button>
                            &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="Updatelic()" [hidden]="isShownUpdateBtn">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear" (click)="Clearlic()">CLEAR</button>
                        </div>
                    </div>

                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>

                </div>

                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin" style="margin-left: -18px;">
                            <div class="card">
                                <div class="card-body" style="width:fit-content;">
                                    <div class="row">
                                        <div class="col-12 grid-margin">
                                            <div class="card">
                                                <div class="card-body" style="padding: 0;">
                                                    <div class="col-lg-12 form-inline"
                                                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                        <div class="col-lg-6"></div>
                                                        <div class="col-lg-6">
                                                            <div class="form-group">
                                                                <div class="input-group">
                                                                    <input type="text" placeholder="Search"
                                                                        [(ngModel)]="searchText" (keyup)="applyFilter($event.target.value)" class="txt-Search">
                                                                         <i class="fa fa-search fa-2x" style="color:#38C3FA;position: absolute; left: 72%; top: 3px;"></i>
                                                                </div>
                                                                <button type="button" class="btn btn-sm ">
                                                                    <img src="../../assets/ExportPDF.png" />
                                                                </button>
                                                                <button type="button" class="btn  btn-sm">
                                                                    <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-sm-12 mat-elevation-z8"
                                                        style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                        <table mat-table [dataSource]="dataSource1" #table
                                                            style="width: 100%;" matSort #sort1="matSort">
                                                            <ng-container matColumnDef="sno">
                                                                <th mat-header-cell *matHeaderCellDef
                                                                    style="color: black !important;background-color: white">
                                                                    S.NO </th>
                                                                <td mat-cell *matCellDef="let item; let j = index">
                                                                    {{(j +1)  + (paginator1.pageIndex * paginator1.pageSize) }}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="number">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    License number</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicmeis(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.number}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="licenseDate1">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    License Date</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicmeis(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.licenseDate1}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="validFrom1">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Valid From</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicmeis(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.validFrom1}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="validTo1">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    ValidTo</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicmeis(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.validTo1}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="roq">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    ROQ</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicmeis(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.roq}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="value">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    License Value</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicmeis(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.value}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="status">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Status</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicmeis(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.status}}
                                                                </td>
                                                            </ng-container>
                                                            <tr mat-header-row *matHeaderRowDef="displayedColumns1">
                                                            </tr>
                                                            <tr mat-row
                                                                *matRowDef="let row; columns: displayedColumns1;">
                                                            </tr>
                                                        </table>
                                                        <mat-paginator #paginator1
                                                            [pageSizeOptions]="[5,10,15,20,30,40]"
                                                            showFirstLastButtons></mat-paginator>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4"></div>
                                        <div class="col-lg-4"></div>
                                        <div class="col-lg-4">

                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>


                <!-- partial:../../partials/_footer.html -->
                <footer class="footer">
                    <div class="d-sm-flex justify-content-center">
                        <span class="d-block d-sm-inline-block">
                            © 2020 All Rights Reserved
                            <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                                <img src="../../assets/Logo-V3.png" width="70" />
                            </a>

                        </span>

                    </div>
                </footer>
                <!-- partial -->
            </div>
        </div>
    </div>

</div>